import { useLang } from '@/i18n';
import { useOnceInView } from '@elem/compPage/on-the-road-power-solution/pages/product/components/US/useOnceInView';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { useState } from 'react';
import css from './index.module.scss';

interface ItfItem {
    name: string;
    text: string;
    img: string;
    tab: string;
    link: string;
    lists: string[];
}
const G: React.FC = () => {
    const { t } = useLang('stream.overview');
    const [activeTab, setActiveTab] = useState(0);
    const items: ItfItem[] = [
        {
            name: 'G_item1_name',
            text: 'G_item1_text',
            img: 'https://websiteoss.ecoflow.com/upload/image/1774595308108/g1.png',
            tab: t('G_tab1'),
            link: 'https://nl.ecoflow.com/products/stream-thuisbatterij?variant=51500400050452',
            lists: ['G_item1_list1', 'G_item1_list2'],
        },
        {
            name: 'G_item2_name',
            text: 'G_item2_text',
            img: 'https://websiteoss.ecoflow.com/upload/image/1774595308269/g2.png',
            tab: t('G_tab2'),
            link: 'https://nl.ecoflow.com/products/stream-thuisbatterij?variant=52037605818644',
            lists: ['G_item2_list1', 'G_item2_list2'],
        },
        {
            name: 'G_item3_name',
            text: 'G_item3_text',
            img: 'https://websiteoss.ecoflow.com/upload/image/1774595308487/g3.png',
            tab: t('G_tab3'),
            link: 'https://nl.ecoflow.com/products/stream-thuisbatterij?variant=52037605884180',
            lists: ['G_item3_list1', 'G_item3_list2'],
        },
    ];

    const handleChangeTab = (i: number) => {
        setActiveTab(i);
    };

    useOnceInView('.stream-nl-G .title', () => {
        document.querySelector('.stream-nl-G .title')?.classList.add('enter');
        document.querySelector('.stream-nl-G .desc')?.classList.add('enter');
        document.querySelector('.stream-nl-G .content')?.classList.add('enter');
    });

    return (
        <div className={`${css.section} stream-nl-G GtmModuleData-section space`} id="stream-nl-G" data-section-id={'stream-nl-G'}>
            <div className="info">
                <h2 className="title ani-1">{t('G_title')}</h2>
                <p className="desc ani-2">
                    {t.rich('G_desc', {
                        y: (tx: string) => <span className="y">{tx}</span>,
                    })}
                </p>
            </div>
            <div className="content box ani-3">
                <ul className="imgs">
                    {items?.map((item: ItfItem, i: number) => (
                        <li className={`img${activeTab === i ? ' active' : ''}`} key={item.img}>
                            <EcoImg pc={item.img} alt={item.name} />
                        </li>
                    ))}
                </ul>
                <div className="inner">
                    <h3 className="question">{t('G_question')}</h3>
                    <ul className="tabs">
                        {items.map((item: ItfItem, i: number) => (
                            <li className={`tab${activeTab === i ? ' active' : ''}`} key={item.tab} onClick={() => handleChangeTab(i)}>
                                {item.tab}
                            </li>
                        ))}
                    </ul>
                    <ul className="items">
                        {items?.map((item: ItfItem, i: number) => (
                            <li className={`item${activeTab === i ? ' active' : ''}`} key={t(item.name)}>
                                <p className="item-name">{t(item.name)}</p>
                                <p className="item-text">
                                    {t.rich(item.text, {
                                        w: (tx: string) => <span className="w">{tx}</span>,
                                    })}
                                </p>
                                <ul className="item-lists">
                                    {item?.lists?.map((list: string) => (
                                        <li className="item-list" key={list}>
                                            {t.rich(list, {
                                                w: (tx: string) => <span className="w">{tx}</span>,
                                            })}
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        ))}
                    </ul>
                    <EcoLink href={items?.[activeTab]?.link} className="item-btn" aria-label={t('G_buy')}>
                        <span>{t('G_buy')}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M5.99219 14.542L12.2573 10.0552L5.99219 5.56787L7.15674 3.94189L14.5571 9.24219C14.8192 9.42999 14.9746 9.73278 14.9746 10.0552C14.9745 10.3776 14.8192 10.6804 14.5571 10.8682L7.15674 16.168L5.99219 14.542Z"
                                fill="black"
                            />
                        </svg>
                    </EcoLink>
                </div>
            </div>
        </div>
    );
};

export default G;
